export const MagnifyingGlassSL = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_9034_8550)">
      <path
        d="M10.408 19.1646C15.2442 19.1646 19.1647 15.2441 19.1647 10.4079 19.1647 5.5716 15.2442 1.6511 10.408 1.6511 5.5717 1.6511 1.6512 5.5716 1.6512 10.4079 1.6512 15.2441 5.5717 19.1646 10.408 19.1646Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.3493 22.3489L16.6002 16.5997"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_9034_8550">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
